export * from './splash-screen.module';
export * from './splash-screen.service';
